export class ResendConfirmationRequestDtoModel {
  email: string;
  mobileNumber: string;
  messageTemplate?: string;
}
